import React from 'react';
import { useSelector } from 'react-redux';

import WhatsAppButton from './components/WhatsAppButton';
import MessengerButton from './components/MessengerButton';
import { withIntercomHeight, withoutIntercomHeight, buttonHeight, defaultMarginBottom } from './constants';

function ChatButtons() {
  const { intercomId } = useSelector((state) => state.core.settings);
  const { enabledWhatsappNumber } = useSelector((state) => state.searchStore.currentSubsidiary) || false;

  const whatsappButtonHeight = intercomId ? withIntercomHeight : withoutIntercomHeight;
  const facebookButtonHeight =
    (intercomId ? buttonHeight : 0) + (enabledWhatsappNumber ? buttonHeight : 0) + defaultMarginBottom;

  return (
    <>
      <WhatsAppButton height={whatsappButtonHeight} />
      <MessengerButton height={facebookButtonHeight} />
    </>
  );
}

export default ChatButtons;
